module.exports = __webpack_public_path__ + "img/mad.49ba8ce8.png";